import React from 'react';
import PropTypes from 'prop-types';
import BSButton from 'react-bootstrap/Button';
export const LinkButton = (props) => {
    let { variant, label, href, block } = props;
    return (React.createElement(BSButton, { type: "button", variant: variant, size: 'xl', href: href, block: block }, label));
};
LinkButton.propTypes = {
    label: PropTypes.string,
    href: PropTypes.string,
};
LinkButton.displayName = 'LinkButton';
